import {Routes, RouterModule} from '@angular/router';
import {AdminComponent} from './admin.component';
import {ManageUsersComponent} from './manage-users/manage-users.component';
import {ConfigComponent} from './config/config.component';
import {AdminGuard} from '../guards/admin.guard';

export const routes: Routes = [
  {
    path: 'admin',
    canActivate: [AdminGuard],
    component: AdminComponent,
    children: [
      {path: '', redirectTo: 'manage-users', pathMatch: 'full'},
      {
        path: 'manage-users',
        component: ManageUsersComponent,
      },
      {
        path: 'config',
        component: ConfigComponent
      },
    ]
  }
];

export const routing = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/admin/admin.routing.ts